import {
	Box,
	Paper,
	Typography
} from "@mui/material";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { TableHomeTaskStlye } from "@styles/layout/TableHomeTaskStlye";	
import { QuestionAndReferenceTabExamRow } from "./QuestionAndReferenceTabExamRow";
import { IExamInfo } from "@repositories/model/transfer/IExamInfo";
import { ChangeFlag } from "@repositories/model/support/ChangeFlag";
import { useTranslation } from "react-i18next";

type Props = {
	projectExamList: IExamInfo[];
	sideBarStepNum: number;
	
	onClickScrollToTopBtn: () => void;
	questionRef: any;

	handleClickRagEdit: () => void;
	handleClickQuestionEdit: () => void;
	isQuestionNumberLabelVisible: boolean;
};


export const QuestionAndReferenceTab = (props: Props) => {
	const classes = useEmotionStyles( TableHomeTaskStlye );
	const { projectExamList, sideBarStepNum, handleClickRagEdit, questionRef, handleClickQuestionEdit, isQuestionNumberLabelVisible } = props;

	const i18next = useTranslation();
	return (
		<Box sx={{ position: 'relative' }} className={classes.tabBoxQuestions}>
			{projectExamList.length > 0 &&
				projectExamList.filter(e => e.changeFlag !== ChangeFlag.DELETED)
					.map((exam, idx) => {
						return (
							<>
								<Typography variant="body1" style={{ fontWeight: 700, backgroundColor: "#ddd", padding: 8 }}>
									{i18next.t("문항 {{problemNumber}})", { problemNumber: idx + 1 })}
								</Typography>
								<Paper sx={{ padding: "16px" }} variant={"outlined"} square={true}>
									<QuestionAndReferenceTabExamRow
										key={exam.key}
										idx={idx}
										examInfo={exam}
										sideBarStepNum={sideBarStepNum}
										handleClickRagEdit={handleClickRagEdit}
										questionRef={questionRef}
										handleClickQuestionEdit={handleClickQuestionEdit}
										isQuestionNumberLabelVisible={isQuestionNumberLabelVisible}
									/>
								</Paper>
							</>
						);
					})}
		</Box>
	);
};